export const API_MAINTENANCE_CODE = "API_MAINTENANCE";
export const TOO_MANY_REQUESTS_CODE = "TOO_MANY_REQUESTS";
